import { PureComponent } from 'react';
import { Notification } from 'platfi-ui-components';
import CSSModules from 'react-css-modules';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { bemModifier } from 'utils/BEMHelper';
import withNotify from 'HOC/withNotify';

import styles from './styles.scss';

@CSSModules(styles, { allowMultiple: true })
class NotifyContainer extends PureComponent {
  static propTypes = {
    closeNotify: PropTypes.func.isRequired,
    isNotifyOpen: PropTypes.bool,
    notifyOptions: PropTypes.shape({
      description: PropTypes.string,
      theme: PropTypes.string,
      title: PropTypes.string,
    }),
  };

  state = {
    visible: false,
  };

  transitionTimeout = null;

  setVisible = (visible) => {
    this.setState({ visible });
  };

  closeNotify = () => {
    this.setState({ visible: false });
  };

  onTransitionEnd = () => {
    const { visible } = this.state;
    const { closeNotify } = this.props;

    if (visible) {
      return;
    }

    closeNotify();
  };

  componentDidUpdate({ isNotifyOpen }) {
    if (!isNotifyOpen && this.props.isNotifyOpen) {
      this.setVisible(true);
      this.transitionTimeout = setTimeout(this.closeNotify, 3000);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.transitionTimeout);
  }

  render() {
    const { visible } = this.state;
    const { isNotifyOpen, notifyOptions } = this.props;

    return !isNotifyOpen ? null : (
      <div
        className="container-fluid"
        onTransitionEnd={this.onTransitionEnd}
        styleName={classNames(...bemModifier('m-notification', { visible }))}
      >
        <Notification onDismiss={this.closeNotify} {...notifyOptions} />
      </div>
    );
  }
}

export default withNotify(NotifyContainer);
